class PasswordValidator {
    constructor(config) {
        this.config = Object.assign({
            password:     '#password',
            confirmation: '#password_confirmation',
            rules: {
                length: { selector: '#rule-length', test: v => v.length >= 12 },
                mixed:  { selector: '#rule-mixed',  test: v => /[A-Z]/.test(v) && /[a-z]/.test(v) },
                number: { selector: '#rule-number', test: v => /[0-9]/.test(v) },
                symbol: { selector: '#rule-symbol', test: v => /[^A-Za-z0-9]/.test(v) },
            }
        }, config);

        this.$password     = $(this.config.password);
        this.$confirmation = $(this.config.confirmation);

        if (this.$password.length > 0) {
            this.init();
        }
    }

    init() {
        this.initRules();
        this.$password.on('input', () => this.evaluate());

        if (this.$confirmation.length > 0) {
            this.initMatchHint();
            this.$password.on('input', () => this.checkMatch());
            this.$confirmation.on('input', () => this.checkMatch());
        }
    }

    initRules() {
        for (const key in this.config.rules) {
            this.config.rules[key].el = $(this.config.rules[key].selector);
        }
    }

    initMatchHint() {
        this.$matchHint = $('<div class="password-match-hint">');
        this.$confirmation.closest('.form-group').append(this.$matchHint);
    }

    evaluate() {
        const val = this.$password.val();
        for (const key in this.config.rules) {
            const rule = this.config.rules[key];
            rule.el.toggleClass('valid', rule.test(val));
        }
    }

    checkMatch() {
        const val  = this.$password.val();
        const conf = this.$confirmation.val();

        if (conf.length === 0) {
            this.$matchHint.text('').attr('class', 'password-match-hint');
            this.$confirmation.removeClass('is-valid is-invalid');
            return;
        }

        const match = val === conf;
        this.$matchHint
            .text(match ? '✓ Wachtwoorden komen overeen' : '✗ Wachtwoorden komen niet overeen')
            .attr('class', 'password-match-hint ' + (match ? 'valid' : 'invalid'));

        this.$confirmation
            .toggleClass('is-valid', match)
            .toggleClass('is-invalid', !match);
    }
}

export default new PasswordValidator;
